/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_No_Events_To_MergeInputs */

const en_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events to merge`)
};

const fr_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement à fusionner`)
};

const de_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ereignisse zum Zusammenführen`)
};

const it_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento da unire`)
};

const ru_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет событий для объединения.`)
};

const es_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos para fusionar`)
};

const zh_cn2_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有要合并的事件`)
};

const ja_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統合するイベントはありません`)
};

const hi_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय करने के लिए कोई इवेंट नहीं हैं`)
};

const pt_pt2_event_group_options_no_events_to_merge = /** @type {(inputs: Event_Group_Options_No_Events_To_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há eventos para mesclar.`)
};

/**
* | output |
* | --- |
* | "No events to merge" |
*
* @param {Event_Group_Options_No_Events_To_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_no_events_to_merge = /** @type {((inputs?: Event_Group_Options_No_Events_To_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_No_Events_To_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_no_events_to_merge(inputs)
	if (locale === "de") return de_event_group_options_no_events_to_merge(inputs)
	if (locale === "it") return it_event_group_options_no_events_to_merge(inputs)
	if (locale === "ru") return ru_event_group_options_no_events_to_merge(inputs)
	if (locale === "es") return es_event_group_options_no_events_to_merge(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_no_events_to_merge(inputs)
	if (locale === "ja") return ja_event_group_options_no_events_to_merge(inputs)
	if (locale === "hi") return hi_event_group_options_no_events_to_merge(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_no_events_to_merge(inputs)
	return en_event_group_options_no_events_to_merge(inputs)
});